import { http } from '../http';

// Geração por código de tipo de termo: vale para qualquer tipo com template
// cadastrado, e não só para os três que tinham rota própria.
export const gerarTermoPorCodigo = async (codigo: string, dados: any) => {
  try {
    const response = await http.post(`/termo/gerar/${encodeURIComponent(codigo)}`, dados);

    if (!response.data || !response.data.termo) {
      throw new Error("Resposta da API inválida.");
    }

    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.mensagem || "Erro ao gerar termo");
  }
};

export const gerarTermoProtecaoCompleta = async (dados: any) => {
  try {
    const response = await http.post('/termo/gerar-protecao-completa', dados);

    if (!response.data || !response.data.termo) {
      throw new Error("Resposta da API inválida.");
    }

    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.mensagem || "Erro ao gerar termo");
  }
};

export const gerarTermoComodatoRastreador = async (dados: any) => {
  try {
    const response = await http.post('/termo/gerar-comodato-rastreador', dados);

    if (!response.data || !response.data.termo) {
      throw new Error("Resposta da API inválida.");
    }

    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.mensagem || "Erro ao gerar termo");
  }
};

export const gerarTermoCienciaEAnuencia = async (dados: any) => {
  try {
    const response = await http.post('/termo/gerar-ciencia-anuencia', dados);

    if (!response.data || !response.data.termo) {
      throw new Error("Resposta da API inválida.");
    }

    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.mensagem || "Erro ao gerar termo");
  }
};
